<nz-layout
  class="care-plan-section"
  [ngClass]="{ 'care-plan-section-editor': addScreen }"
>
  <nz-header> </nz-header>
  <nz-content>
    @if (!addScreen) {
      <app-care-plan />
    }

    @if (addScreen) {
      <app-care-plan-add-edit />
    }
  </nz-content>
</nz-layout>
